import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import axios from "axios";

const BASE_URL = "http://localhost:3000/";

import createPersistedState from "vuex-persistedstate";
import createMutationsSharer from "vuex-shared-mutations";
// import sessionManager from "./modules/session_manager";
// import SecureLS from "secure-ls";
// const ls = new SecureLS({ isCompression: false });
Vue.use(Vuex);

export const store = new Vuex.Store({
  state() {
    return {
      packageVersion: process.env.VUE_APP_VERSION || "0",
      currentUser: {},
      user: {},
      user_settings: {},
      auth_token: null,
      company: {
        mileage_limit: 0,
        mileage_limit_cost: 0,
      },
      main_company: {
        balance: 0,
        payer_state: 0,
        currency: "EUR",
      },
      doc_template_url: "https://web.rentprog.ru/doc_example.docx",
      entity_doc_template_url:
        "https://web.rentprog.ru/entity_doc_example.docx",
      invoice_template_url: "https://web.rentprog.ru/invoice_example.docx",
      prolong_template_url: "https://web.rentprog.ru/prolong_example.docx",
      login_users: [],
      messages: [],
      csrf: null,
      login_time: null,
      todos: [],
      drawer: false,
      show_active_bookings: true,
      show_ride_bookings: true,
      signedIn: false,
      snackbar: false,
      // servicesCheck: false,
      searchInBookings: null,
      sortDateInBookings: null,
      sortStateInBookings: null,
      new_booking: false,
      show_banner: true,
      show_store_kits: false,
      bannerRemoveDemoContent: false,
      tour_next_step: false,
      car_tab: 0,
      whatsapp_search_client: null,
      finance_mode: false,
      teletype_messages_count: 0,
      teletype_messages: [],
      teletype_lastMessage: null,
      teletype_dialogs: [],
      teletype_dialog_messages: {},
      teletype_active_dialog: null,
      teletype_loading: false,
      company_profile_tab: 0,
      has_new_ticket: false,
    };
  },
  getters: {
    // !!!!!
    getAuthToken(state) {
      return state.auth_token;
    },
    getUserEmail(state) {
      return state.user ? state.user.email : null;
    },
    getUserID(state) {
      return state.user ? state.user.id : null;
    },
    isLoggedIn(state) {
      const loggedOut =
        state.auth_token == null || state.auth_token == JSON.stringify(null);
      return !loggedOut;
    },
    // !!!!
    appVersion: (state) => {
      return state.packageVersion;
    },
    isAdmin(state) {
      return state.currentUser.role === "admin";
    },
    isManager(state) {
      return state.currentUser.role === "manager";
    },
    isSuperAdmin(state) {
      return state.currentUser.role === "superadmin";
    },
    isPartner(state) {
      return state.currentUser.role === "partner";
    },
    isGuest(state) {
      return state.currentUser.role === "guest";
    },
    currentUserId(state) {
      return state.currentUser && state.currentUser.id;
    },
    getDrawer(state) {
      return state.drawer;
    },
    getShowActiveBookings(state) {
      return state.show_active_bookings;
    },
    getShowRideBookings(state) {
      return state.show_ride_bookings;
    },
    getCurrentUser(state) {
      return state.currentUser;
    },
    getCompany(state) {
      return state.company;
    },
    getMainCompany(state) {
      return state.main_company;
    },
    getCompanyId(state) {
      return state.company.company.id;
    },
    getDocUrl(state) {
      return state.doc_template_url;
    },
    getEntityDocUrl(state) {
      return state.entity_doc_template_url;
    },
    getInvoiceUrl(state) {
      return state.invoice_template_url;
    },
    getProlongTemplateUrl(state) {
      return state.prolong_template_url;
    },
    getServicesCheck(state) {
      return state.servicesCheck;
    },
    getMessages(state) {
      return state.messages;
    },
    getCSRF(state) {
      return state.csrf;
    },
    getSignedIn(state) {
      return state.signedIn;
    },
    getLoginUsers(state) {
      return state.login_users;
    },
    getLoginTime(state) {
      return state.login_time;
    },
    getSearchInBookings(state) {
      return state.searchInBookings;
    },
    getSortDateInBookings(state) {
      return state.sortDateInBookings;
    },
    getSortStateInBookings(state) {
      return state.sortStateInBookings;
    },
    getNewBookingState(state) {
      return state.new_booking;
    },
    getShowBanner(state) {
      return state.show_banner;
    },
    getStoreKits(state) {
      return state.show_store_kits;
    },
    getBannerRemoveDemoContent(state) {
      return state.bannerRemoveDemoContent;
    },
    getTourNextStep(state) {
      return state.tour_next_step;
    },
    getCarTab(state) {
      return state.car_tab;
    },
    getUserSettings(state) {
      return state.user_settings;
    },
    getWhatsappSearchClient(state) {
      return state.whatsapp_search_client;
    },
    getFinanceMode(state) {
      return state.finance_mode;
    },
    getTeletypeMessagesCount(state) {
      return state.teletype_messages_count;
    },
    getTeletypeMessages(state) {
      return state.teletype_messages;
    },
    getTeletypeLastMessage(state) {
      return state.teletype_lastMessage;
    },
    getTeletypeDialogs(state) {
      return state.teletype_dialogs;
    },
    getTeletypeActiveDialog(state) {
      return state.teletype_active_dialog;
    },
    getTeletypeDialogMessages: state => dialogId => {
      return state.teletype_dialog_messages[dialogId] || [];
    },
    getTeletypeLoading(state) {
      return state.teletype_loading;
    },
    getCompanyProfileTab(state) {
      return state.company_profile_tab;
    },
    getHasNewTicket(state) {
      return state.has_new_ticket;
    },
  },
  mutations: {
    setUserInfo(state, data) {
      state.user = data.data.user;
      state.auth_token = data.headers.authorization;
      axios.defaults.headers.common["Authorization"] =
        data.headers.authorization;
      localStorage.setItem("auth_token", data.headers.authorization);
      state.currentUser = data.data.user;
      state.signedIn = true;
      state.login_time = Date.now();
    },
    setUserSettings(state, data) {
      state.user_settings = data;
    },
    setUserInfoFromToken(state, data) {
      state.user = data.data.user;
      state.auth_token = localStorage.getItem("auth_token");
    },
    setAuthToken(state, token) {
      state.auth_token = token;
    },
    // !!!!
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser;
      state.signedIn = true;
      // state.csrf = csrf;
      state.login_time = Date.now();
    },
    unsetCurrentUser(state) {
      state.user = {};
      state.auth_token = null;
      state.signedIn = false;
      localStorage.removeItem("auth_token");
      axios.defaults.headers.common["Authorization"] = null;
      // В роутере уже есть редирект, но без Signin
      // router.push({ name: "Signin" }).catch(() => false);
      router.go();

      state.currentUser = {};
      state.signedIn = false;
      state.csrf = null;
      state.company = {};
      state.main_company = {};
      state.login_time = null;
      state.todos = [];
      state.drawer = false;
      state.show_active_bookings = true;
      state.show_ride_bookings = false;
      state.searchInBookings = null;
      state.sortDateInBookings = null;
      state.login_users = [];
      state.packageVersion = 0;
    },
    refresh(state, csrf) {
      state.signedIn = true;
      state.csrf = csrf;
    },
    setCompany(state, company) {
      state.company = company;
    },
    setMainCompany(state, main_company) {
      state.main_company = main_company;
    },
    setMessages(state, messages) {
      state.messages = messages;
    },
    addMessage(state, message) {
      let old_data = state.messages;
      old_data.unshift(message);
    },
    removeMessage(state, message) {
      let old_data = state.messages;
      let index = old_data.findIndex((item) => item.id == message.id);
      old_data.splice(index, 1);
    },
    setHasNewTicket(state, has_new_ticket) {
      state.has_new_ticket = has_new_ticket;
    },
    setDocUrl(state, url) {
      state.doc_template_url = url;
    },
    setEntityDocUrl(state, url) {
      state.entity_doc_template_url = url;
    },
    setInvoiceUrl(state, url) {
      state.invoice_template_url = url;
    },
    setProlongTemplateUrl(state, url) {
      state.prolong_template_url = url;
    },
    setLoginUsers(state, user) {
      let arr_users = [];
      // Текущие
      state.login_users.forEach((item) => {
        arr_users.push(item);
      });

      // Чистим массив от дублей
      if (arr_users.findIndex((item) => item.id == user.id) >= 0) {
        function removeDuplicates(myArr, prop) {
          return myArr.filter((obj, pos, arr) => {
            return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
          });
        }
        arr_users = removeDuplicates(arr_users, "id");
      }

      if (user.login == true) {
        let index = arr_users.findIndex((item) => item.id == user.id);
        // Добавляем нового
        if (index == -1) {
          arr_users.push(user);
        } else {
          arr_users.splice(index, 1, { id: user.id, login: true });
        }
      }

      // console.log("user", user);
      if (user.login == false) {
        // console.log("user login false", user);
        let index = arr_users.findIndex((item) => item.id == user.id);
        if (index >= 0) {
          arr_users.splice(index, 1, { id: user.id, login: false });
        }
        // let index = arr_users.findIndex(item => item.id == user.id)
        // if (index >= 0) {
        //   let finded_user = arr_users.find(item => item.id == user.id)
        //   arr_users = arr_users.filter(item => item.id != finded_user.id)
        //   console.log("finded_user", finded_user)
        //   console.log("arr_users", arr_users)
        // }
      }

      // console.log(arr_users);

      return (state.login_users = arr_users);
    },
    show_active_bookings(state) {
      return (state.show_active_bookings = !state.show_active_bookings);
    },
    show_ride_bookings(state, value) {
      return (state.show_ride_bookings = value);
    },
    setDrawer(state, value) {
      return state.drawer = value;
    },
    servicesCheckTrue(state) {
      return (state.servicesCheck = true);
    },
    servicesCheckFalse(state) {
      return (state.servicesCheck = false);
    },
    setSearchInBookings(state, search) {
      return (state.searchInBookings = search);
    },
    setsortDateInBookings(state, range) {
      return (state.sortDateInBookings = range);
    },
    setSortStateInBookings(state, value) {
      return (state.sortStateInBookings = value);
    },
    setNewBooking(state, new_booking_exists) {
      state.new_booking = new_booking_exists;
    },
    setShowBanner(state, close_banner) {
      state.show_banner = close_banner;
    },
    setStoreKits(state) {
      state.show_store_kits = !state.show_store_kits;
    },
    setBannerRemoveDemoContent(state) {
      state.bannerRemoveDemoContent = !state.bannerRemoveDemoContent;
    },
    setTourNextStep(state, force) {
      state.tourNextStep = force;
    },
    setCarTab(state, tab) {
      state.car_tab = tab;
    },
    setWhatsappSearchClient(state, search) {
      state.whatsapp_search_client = search;
    },
    setFinanceMode(state, mode) {
      state.finance_mode = mode;
    },
    addTeletypeNewMessage(state, payload) {
      if (payload && payload.message) {
        state.teletype_messages_count++;

        const newMessage = payload.message;
        state.teletype_messages.unshift(newMessage);

        if (state.teletype_messages.length > 50) {
          state.teletype_messages = state.teletype_messages.slice(0, 50);
        }

        state.teletype_lastMessage = newMessage;

        // Если сообщение относится к активному диалогу, добавляем его туда
        if (newMessage.dialogId && state.teletype_dialog_messages[newMessage.dialogId]) {
          this.commit('addTeletypeDialogMessage', {
            dialogId: newMessage.dialogId,
            message: newMessage
          });
        }
      }
    },
    resetTeletypeMessagesCount(state) {
      state.teletype_messages_count = 0;
    },
    incrementTeletypeMessagesCount(state) {
      state.teletype_messages_count++;
    },
    markTeletypeMessageAsRead(state, messageId) {
      const messageIndex = state.teletype_messages.findIndex(msg => msg.id === messageId);
      if (messageIndex >= 0) {
        const updatedMessage = { ...state.teletype_messages[messageIndex], read: true };
        state.teletype_messages.splice(messageIndex, 1, updatedMessage);
      }
    },
    removeTeletypeMessage(state, messageId) {
      state.teletype_messages = state.teletype_messages.filter(msg => msg.id !== messageId);
    },
    setTeletypeDialogs(state, dialogs) {
      state.teletype_dialogs = dialogs.map(dialog => ({
        ...dialog,
        hasUnreadMessages: dialog.unreadCount > 0,
        hasActiveBooking: false // можно расширить проверкой бронирований
      }));
    },
    addTeletypeDialog(state, dialog) {
      const index = state.teletype_dialogs.findIndex(d => d.id === dialog.id);
      if (index >= 0) {
        // Обновление существующего диалога
        state.teletype_dialogs.splice(index, 1, {
          ...dialog,
          hasUnreadMessages: dialog.unreadCount > 0,
          hasActiveBooking: false
        });
      } else {
        // Добавление нового диалога
        state.teletype_dialogs.push({
          ...dialog,
          hasUnreadMessages: dialog.unreadCount > 0,
          hasActiveBooking: false
        });
      }
    },
    setTeletypeActiveDialog(state, dialog) {
      state.teletype_active_dialog = dialog;
    },
    setTeletypeLoading(state, isLoading) {
      state.teletype_loading = isLoading;
    },
    setTeletypeDialogMessages(state, { dialogId, messages }) {
      // Используем Vue.set для реактивного обновления
      Vue.set(state.teletype_dialog_messages, dialogId, messages);
    },
    addTeletypeDialogMessage(state, { dialogId, message }) {
      if (!state.teletype_dialog_messages[dialogId]) {
        Vue.set(state.teletype_dialog_messages, dialogId, []);
      }

      // Проверка на дубликаты
      const existingIndex = state.teletype_dialog_messages[dialogId].findIndex(m => m.id === message.id);
      if (existingIndex >= 0) {
        // Обновляем существующее сообщение
        state.teletype_dialog_messages[dialogId].splice(existingIndex, 1, message);
      } else {
        // Добавляем новое сообщение
        state.teletype_dialog_messages[dialogId].push(message);

        // Сортируем сообщения по времени (от старых к новым)
        state.teletype_dialog_messages[dialogId].sort((a, b) => {
          const timeA = a.createdAt?.date ? new Date(a.createdAt.date).getTime() :
            (a.timestamp ? (typeof a.timestamp === 'number' ? a.timestamp * 1000 : new Date(a.timestamp).getTime()) : 0);
          const timeB = b.createdAt?.date ? new Date(b.createdAt.date).getTime() :
            (b.timestamp ? (typeof b.timestamp === 'number' ? b.timestamp * 1000 : new Date(b.timestamp).getTime()) : 0);
          // Меняем порядок сортировки
          return timeB - timeA;
        });
      }
    },
    updateTeletypeMessageStatus(state, { dialogId, messageId, status }) {
      if (state.teletype_dialog_messages[dialogId]) {
        const messageIndex = state.teletype_dialog_messages[dialogId].findIndex(m => m.id === messageId);
        if (messageIndex >= 0) {
          const updatedMessage = { ...state.teletype_dialog_messages[dialogId][messageIndex], status };
          state.teletype_dialog_messages[dialogId].splice(messageIndex, 1, updatedMessage);
        }
      }
    },
    updateTeletypeDialog(state, { dialogId, lastMessage }) {
      const dialogIndex = state.teletype_dialogs.findIndex(d => d.id === dialogId);
      if (dialogIndex >= 0) {
        const dialog = { ...state.teletype_dialogs[dialogIndex] };

        // Обновляем последнее сообщение и время
        dialog.lastMessage = lastMessage;
        if (lastMessage.createdAt && lastMessage.createdAt.date) {
          dialog.lastMessageAt = lastMessage.createdAt;
        }

        // Если сообщение от клиента и это не активный диалог, отмечаем его как непрочитанный
        if ((lastMessage.isItClient || lastMessage.isOutgoing === false) &&
          (!state.teletype_active_dialog || state.teletype_active_dialog.id !== dialogId)) {
          dialog.hasUnreadMessages = true;
          dialog.unreadCount = dialog.unreadCount ? dialog.unreadCount + 1 : 1;
        }

        // Обновляем диалог в списке
        Vue.set(state.teletype_dialogs, dialogIndex, dialog);

        // Перемещаем диалог в начало списка
        if (dialogIndex > 0) {
          const updatedDialog = state.teletype_dialogs.splice(dialogIndex, 1)[0];
          state.teletype_dialogs.unshift(updatedDialog);
        }
      }
    },
    updateTeletypeDialogMessageStatus(state, { dialogId, messageId, status }) {
      const dialogIndex = state.teletype_dialogs.findIndex(d => d.id === dialogId);
      if (dialogIndex >= 0) {
        const dialog = { ...state.teletype_dialogs[dialogIndex] };

        // Если последнее сообщение в диалоге - это сообщение, статус которого изменился
        if (dialog.lastMessage && dialog.lastMessage.id === messageId) {
          // Обновляем статус последнего сообщения
          dialog.lastMessage.status = status;

          // Обновляем диалог в списке
          Vue.set(state.teletype_dialogs, dialogIndex, dialog);
        }
      }
    },
    markTeletypeDialogAsRead(state, dialogId) {
      const dialogIndex = state.teletype_dialogs.findIndex(d => d.id === dialogId);
      if (dialogIndex >= 0) {
        const dialog = { ...state.teletype_dialogs[dialogIndex] };
        dialog.hasUnreadMessages = false;
        dialog.unreadCount = 0;

        // Обновляем диалог в списке
        Vue.set(state.teletype_dialogs, dialogIndex, dialog);
      }
    },
    addTeletypeDialogFromMessage(state, payload) {
      const { message } = payload;

      // Проверяем, существует ли диалог
      const existingDialogIndex = state.teletype_dialogs.findIndex(d => d.id === message.dialogId);

      if (existingDialogIndex === -1) {
        // Создаем новый диалог на основе сообщения
        const newDialog = {
          id: message.dialogId,
          client: message.client || null,
          title: message.client ? message.client.name : (message.channel ? message.channel.name : 'Новый диалог'),
          channel: message.channel || {},
          lastMessage: message,
          lastMessageAt: message.createdAt,
          hasUnreadMessages: true,
          unreadCount: 1
        };

        // Добавляем диалог в начало списка
        state.teletype_dialogs.unshift(newDialog);

        // Инициализируем список сообщений для нового диалога
        Vue.set(state.teletype_dialog_messages, message.dialogId, [message]);
      }
    },
    updateTeletypeMessage(state, { dialogId, messageId, updates }) {
      if (state.teletype_dialog_messages[dialogId]) {
        const messageIndex = state.teletype_dialog_messages[dialogId].findIndex(m => m.id === messageId);
        if (messageIndex >= 0) {
          const updatedMessage = {
            ...state.teletype_dialog_messages[dialogId][messageIndex],
            ...updates
          };
          state.teletype_dialog_messages[dialogId].splice(messageIndex, 1, updatedMessage);
        }
      }
    },
    setTeletypeDialogUnread(state, { dialogId, unreadCount }) {
      const dialogIndex = state.teletype_dialogs.findIndex(d => d.id === dialogId);
      if (dialogIndex >= 0) {
        const dialog = { ...state.teletype_dialogs[dialogIndex] };
        dialog.hasUnreadMessages = true;
        dialog.unreadCount = unreadCount;

        // Обновляем диалог в списке
        Vue.set(state.teletype_dialogs, dialogIndex, dialog);
      }
    },
    setCompanyProfileTab(state, tab) {
      state.company_profile_tab = tab;
    },
  },
  actions: {
    loginUserWithToken({ commit }, payload) {
      const config = {
        headers: {
          Authorization: payload.auth_token,
        },
      };
      new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}member-data`, config)
          .then((response) => {
            commit("setUserInfoFromToken", response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadTeletypeDialogs({ commit, state }, { page = 1, pageSize = 50 } = {}) {
      commit('setTeletypeLoading', true);

      return new Promise((resolve, reject) => {
        axios.get('/api/v1/integrations/teletype/dialogs', {
          headers: {
            Authorization: state.auth_token
          },
          params: {
            page: page,
            page_size: pageSize
          }
        })
          .then(response => {
            if (response.data && response.data.data) {
              if (response.data.data.items) {
                commit('setTeletypeDialogs', response.data.data.items);
              }

              // Возвращаем информацию о пагинации
              resolve({
                totalPages: response.data.data.totalPages || 1,
                currentPage: response.data.data.currentPage || 1,
                items: response.data.data.items || []
              });
            } else {
              commit('setTeletypeDialogs', []);
              resolve({ totalPages: 1, currentPage: 1, items: [] });
            }
          })
          .catch(error => {
            console.error('Ошибка при загрузке диалогов:', error);
            reject(error);
          })
          .finally(() => {
            commit('setTeletypeLoading', false);
          });
      });
    },
    loadTeletypeDialogMessages({ commit, state }, dialogId) {
      if (!dialogId) return Promise.reject(new Error('Не указан ID диалога'));

      commit('setTeletypeLoading', true);

      return new Promise((resolve, reject) => {
        axios.get('/api/v1/integrations/teletype/messages', {
          headers: {
            Authorization: state.auth_token
          },
          params: {
            dialog_id: dialogId,
            page_size: 100
          }
        })
          .then(response => {
            if (response.data && response.data.data && response.data.data.items) {
              const messages = response.data.data.items;
              commit('setTeletypeDialogMessages', { dialogId, messages });
              resolve(messages);
            } else {
              commit('setTeletypeDialogMessages', { dialogId, messages: [] });
              resolve([]);
            }
          })
          .catch(error => {
            console.error('Ошибка при загрузке сообщений:', error);
            reject(error);
          })
          .finally(() => {
            commit('setTeletypeLoading', false);
          });
      });
    },
    sendTeletypeMessage({ commit, state }, { dialogId, text, file }) {
      if (!dialogId) return Promise.reject(new Error('Не указан ID диалога'));

      commit('setTeletypeLoading', true);

      const formData = new FormData();
      formData.append('dialog_id', dialogId);

      if (text && text.trim() !== '') {
        formData.append('text', text);
      }

      if (file) {
        formData.append('file', file);
      }

      return new Promise((resolve, reject) => {
        axios.post('/api/v1/integrations/teletype/create_message', formData, {
          headers: {
            'Authorization': state.auth_token,
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
            if (response.data && response.data.success) {
              // Создаем временное сообщение для отображения
              const sentMessage = {
                id: response.data.data && response.data.data.ids ? response.data.data.ids[0] : Date.now().toString(),
                dialogId: dialogId,
                type: file ? 'file' : 'text',
                text: text,
                sender: 'user',
                timestamp: Math.floor(Date.now() / 1000),
                isOutgoing: true,
                status: 10 // Статус "отправляется"
              };

              commit('addTeletypeDialogMessage', { dialogId, message: sentMessage });
              resolve(sentMessage);
            } else {
              reject(new Error('Неуспешный ответ от сервера'));
            }
          })
          .catch(error => {
            console.error('Ошибка при отправке сообщения:', error);
            reject(error);
          })
          .finally(() => {
            commit('setTeletypeLoading', false);
          });
      });
    },
    loadMessagesForDialog(dialog) {
      // ... существующий код ...

      // Устанавливаем активный диалог в store
      this.$store.commit('setTeletypeActiveDialog', dialog);

      // Отмечаем диалог как прочитанный
      if (dialog.hasUnreadMessages) {
        this.markDialogAsRead(dialog.id);
      }

      // ... остальной код ...
    },
  },
  modules: {
    // sessionManager,
  },
  plugins: [
    createPersistedState(),
    // Сохраняет мутации в разных вкладках
    createMutationsSharer({
      predicate: [
        "refresh",
        "setCurrentUser",
        "unsetCurrentUser",
        "show_active_bookings",
        "show_ride_bookings",
        "servicesCheckTrue",
        "servicesCheckFalse",
        "setSearchInBookings",
        "setsortDateInBookings",
        "setFinanceMode",
        "addTeletypeNewMessage",
        "resetTeletypeMessagesCount",
      ],
      // storage: {
      //   getItem: (key) => ls.get(key),
      //   setItem: (key, value) => ls.set(key, value),
      //   removeItem: (key) => ls.remove(key)
      // }
    }),
  ],
});
